$(document).ready(function(){
  $("[data-rate-post] [data-rate-voted]").hide();
  $("body").on("click","[data-rate-post] label",function(){
      parent = $(this).closest('[data-rate-post]');
      $.post("/module/postrate",{
        "post_id": $(this).closest("[data-rate-post]").attr("data-rate-post"),
        "rate": $(this).attr('data-value'),
        "_token": window.Laravel.csrfToken
      },function(response){
        parent.find('label.active').removeClass('active');
        console.log(response);
        if(response.rate>0)
          parent.find('label[data-value="1"]').addClass('active');
        for(var i=1;i<4;i++){
          if(response.rate>=i){
            parent.find('label[data-value="'+i+'"]').addClass('active');
          }
        }
        if(response.rate==5)
          parent.find('label[data-value="5"]').addClass('active');

        $("[data-rate-voted]").hide();
        if(response.code == 1){
          console.log('1');
          $('[data-rate-success]').show();
        }else{
          console.log('0');
          $('[data-rate-failure]').show();
        }

        $("[data-rate-value]").html(parseFloat(response.rate).toFixed(1));
        $("[data-rate-counter]").html(response.counter);
      });
  });

});
